import {Component} from "@angular/core";
import {GeneralService} from "../../../../services/generalService";
import {NotificationService} from "../../../../services/notificationService";
import {RouteService} from "../../../../services/routeService";
import {DICTIONARY} from "../../../../dictionary";

@Component({
	selector: "url-decoder-tool-component",
	templateUrl: "./url-decoder-tool.component.html",
})
export class UrlDecoderToolComponent {
	constructor(public gs: GeneralService,
				private ns: NotificationService,
				private rs: RouteService) {}

	dic = DICTIONARY;
	urlTxt;
	decodeUrlInProcess;
	decodeUrlResult;

	decodeUrl = () => {
		if (!this.urlTxt) {
			return;
		}

		this.decodeUrlInProcess = true;
		this.decodeUrlResult = null;

		this.rs.runTool('urlDecoder', {url: this.urlTxt.trim()}).then((res) => {
			this.decodeUrlResult = res;
			this.decodeUrlInProcess = false;
		}, (err) => {
			this.decodeUrlInProcess = false;
		});
	};
}
